// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footerContent":"Footer_footerContent__BSOz6","footerSection":"Footer_footerSection__Km-0V","footerBottom":"Footer_footerBottom__gK74T"};